export default "__VITE_ASSET__CA26D9Ic__"